import React from "react";
import requestFunc from "../request/request";
import axios from "axios";
import { message, Button, Modal } from "antd";

export const api = {
  login(option) {
    return new Promise((resolve) => {
      // requestFunc("POST", "/ws/app/login", params).then(res => {
      axios(option).then((res) => {
        resolve(res.data);
      });
    });
  },
  getUsers() {
    return new Promise((resolve) => {
      requestFunc("GET", "/ws/app/users").then((res) => {
        if (res.data.ec === 0) {
          resolve(res.data.resp.Users);
        } else {
          resolve([]);
        }
      });
    });
  },
};
